<template>
  <v-drawer :direction="'right'" :width="'26%'">
    <bar-card :bg="'border10'">
      <div class="card-border">
        <div style="height: 100%">
          <div style="height: 22%">
            <c-title :item="obj"> </c-title>
            <div class="tiImgBox">
              <swiper :options="swiperOptionS" class="imgcases" ref="mySwiper">
                <!-- :slides-per-view="3"
                :space-between="50"
                @swiper="onSwiper"
                @slideChange="onSlideChange" -->
                <swiper-slide v-for="(item, i) in swiperList" :key="i">
                  <div class="tjBox">
                    <div
                      class="tjList"
                      v-for="(arr, k) in item.fz"
                      :key="k"
                      @click="lzclick(i, k)"
                    >
                      <div class="tjImgBox">
                        <img
                          v-if="arr.image_path"
                          style="cursor:pointer;"
                          :src="getImgUrl(arr.image_path)"
                        />
                        <p
                          v-if="
                            arr.recognition_json &&
                              arr.recognition_json.data &&
                              arr.recognition_json.data.length > 0
                          "
                        >
                          <span
                            v-for="(parr, p) in arr.recognition_json.data"
                            :key="p"
                          >
                            {{ parr.name }}:{{ parr.number }}只
                          </span>
                        </p>
                      </div>
                      <div class="imgMsg">
                        <div class="nopx-imgLine"></div>
                        <div class="nopx-imgYuan"></div>
                        <p>
                          {{
                            $formatDate(new Date(arr.time), "yyyy-MM-dd hh:mm")
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- {{ item }} -->
                </swiper-slide>
              </swiper>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
              <img :src="bchLine" alt="" class="bchLine" />
            </div>
          </div>

          <div style="height:78%">
            <c-title :item="lsObj"> </c-title>
            <div class="chart-box">
              <div class="clzsBox">
                <p class="bchTitle">虫量走势</p>
                <el-tabs v-model="time" @tab-click="handleClick">
                  <el-tab-pane label="近15天" name="15"></el-tab-pane>
                  <el-tab-pane label="近60天" name="60"></el-tab-pane>
                  <el-tab-pane label="近6个月" name="180"></el-tab-pane>
                  <el-tab-pane label="近12个月" name="365"></el-tab-pane>
                </el-tabs>
                <div class="chart chart2" ref="clzs"></div>
              </div>
              <div class="clzybBox">
                <p class="bchTitle">近5月虫量占有比</p>
                <div class="chart" ref="clzyb"></div>
              </div>
            </div>
          </div>
        </div>
        <image-preview
          :show.sync="imgpre"
          :list="imglist"
          :names="imgnames"
          :initialIndex="initialIndex"
        ></image-preview>
      </div>
    </bar-card>
  </v-drawer>
</template>

<script>
import cTitle from "../components/title";
// import { loadChart } from "./chart/chartData";
import { mapGetters } from "vuex";
// import { findQxzWlwnNwestData, findWlwWeatherGetLSSJ } from "@/api/zhwl";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { loadClzsChart } from "./chart/clzsData";
import { loadClzybChart } from "./chart/clzybData";
import {
  getWlwPestImageTj,
  getWlwPestDataLimitFive,
  getWlwPestDataTypeSum,
} from "@/api/zhwl";
const imagePreview = () => import("@/components/imagePreview");
export default {
  components: {
    cTitle,
    Swiper,
    SwiperSlide,
    imagePreview,
  },
  computed: {
    ...mapGetters(["graphic"]),
  },
  watch: {
    graphic() {
      this.dataLoad();
      this.getClzsData();
    },
  },
  data() {
    return {
      obj: {
        src: require("images/zhwl/icon_sssj.png"),
        name: "病虫害识别图集",
        hasBtn: true,
        left: true,
      },
      lsObj: {
        src: require("images/zhwl/icon_lssj.png"),
        name: "主要虫害数量变化趋势",
        hasBtn: false,
        left: true,
      },
      time: "15",
      list: [
        // {
        //   src: require("images/zhwl/qw.png"),
        //   name: "温度",
        //   value: "31",
        //   unit: "℃"
        // },
        // {
        //   src: require("images/zhwl/sd.png"),
        //   name: "湿度",
        //   value: "50",
        //   unit: "%"
        // },
        // {
        //   src: require("images/zhwl/fx-right.png"),
        //   name: "风向",
        //   value: "向右"
        // },
        // {
        //   src: require("images/zhwl/fs.png"),
        //   name: "风速",
        //   value: "5",
        //   unit: "m/s"
        // },
        // {
        //   src: require("images/zhwl/qy.png"),
        //   name: "气压",
        //   value: "20",
        //   unit: "mpa"
        // },
        // {
        //   src: require("images/zhwl/yl.png"),
        //   name: "雨量",
        //   value: "200",
        //   unit: "mm"
        // }
      ],
      bchLine: require("images/zhwl/bchLine.png"),
      swiperOptionS: {
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: false,
        observeParents: true,
        observer: true,
        slidesPerView: "auto", //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        centeredSlides: true, //<span style="color:rgb(68,68,68);font-family:'microsoft yahei';font-size:13px;">设定为true时，活动块会居中，而不是默认状态下的居左。</span>
        // prevButton: ".swiper-button-prev", //上一张
        // nextButton: ".swiper-button-next", //下一张
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        swiperPage: 0,
        loop: true,
      },
      swiperList: [],
      endTime: this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      startTime: this.$formatDate(
        new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd hh:mm:ss"
      ),
      imgpre: false,
      imglist: [],
      imgnames: [],
      initialIndex: 0,
    };
  },
  mounted() {
    this.dataLoad();
    this.getClzsData();
  },
  methods: {
    lzclick(i, k) {
      this.initialIndex = i * 3 + k;
      this.imgpre = true;
    },
    handleClick() {
      //   if (val.name === "15") {
      //     this.startTime = this.$formatDate(
      //       new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
      //       "yyyy-MM-dd hh:mm:ss"
      //     );
      //   } else if (val.name === "60") {
      //     this.startTime = this.$formatDate(
      //       new Date(new Date().getTime() - 60 * 24 * 60 * 60 * 1000),
      //       "yyyy-MM-dd hh:mm:ss"
      //     );
      //   } else if (val.name === "180") {
      //     this.startTime = this.$formatDate(
      //       new Date(new Date().getTime() - 180 * 24 * 60 * 60 * 1000),
      //       "yyyy-MM-dd hh:mm:ss"
      //     );
      //   } else {
      //     this.startTime = this.$formatDate(
      //       new Date(new Date().getTime() - 365 * 24 * 60 * 60 * 1000),
      //       "yyyy-MM-dd hh:mm:ss"
      //     );
      //   }
      this.getClzsData();
    },
    getImgUrl(v) {
      if (v != null) {
        let http = /^http[s]{0,1}:\/\/.*/i.test(v);
        if (!http) {
          return window.__config.VUE_APP_IMG_URL + v;
        } else {
          return v;
        }
      }
      return "";
    },
    dataLoad() {
      this.obj.name = this.graphic.name;
      getWlwPestImageTj({
        deviceId: this.graphic.code || "CQ01A-2000004",
      }).then((res) => {
        let arr = [];
        let narr = [];
        res = res.map((ele) => {
          const imgPath = window.__config.VUE_APP_IMG_URL + ele.image_path;
          arr.push(imgPath);

          let pest_name = "";
          if (
            ele.recognition_json &&
            typeof ele.recognition_json !== "object"
          ) {
            let obj = JSON.parse(ele.recognition_json);
            ele.recognition_json = obj;
            if (obj && Array.isArray(obj.data) && obj.data.length > 0) {
              pest_name = obj.data
                .map((e) => {
                  return e.name + ":" + e.number + "只";
                })
                .join(";");
            }
          } else {
            const obj = ele.recognition_json;
            if (obj && Array.isArray(obj.data) && obj.data.length > 0) {
              pest_name = obj.data
                .map((e) => {
                  return e.name + ":" + e.number + "只";
                })
                .join(";");
            }
          }
          narr.push(pest_name);
          return ele;
        });
        this.imglist = arr;
        this.imgnames = narr;

        this.swiperPage = Math.ceil(res.length / 3);
        let swiperList = [];

        for (let i = 0; i < this.swiperPage; i++) {
          arr.push();
          let dataList = [];
          if (res[i * 3]) {
            dataList.push(res[i * 3]);
          }
          if (res[i * 3 + 1]) {
            dataList.push(res[i * 3 + 1]);
          }
          if (res[i * 3 + 2]) {
            dataList.push(res[i * 3 + 2]);
          }
          //   dataList.push(, res[i * 3 + 2], res[i * 3 + 3]);
          swiperList.push({
            fz: dataList,
          });
        }
        this.swiperList = swiperList;
      });

      getWlwPestDataLimitFive({
        wlwInfoCode: this.graphic.code || "CQ01A-2000004",
      }).then((res) => {
        this.clzybChart = this.$echarts.init(this.$refs.clzyb);
        loadClzybChart(this.clzybChart, res);
        window.addEventListener("resize", () => {
          this.clzybChart.resize();
        });
      });
    },

    //获取虫量走势
    getClzsData() {
      getWlwPestDataTypeSum({
        wlwInfoCode: this.graphic.code || "CQ01A-2000004",
        dateNum: this.time,
      }).then((res) => {
        this.clzsChart = this.$echarts.init(this.$refs.clzs);
        loadClzsChart(this.clzsChart, res);
        // window.addEventListener("resize", () => {
        //   this.clzsChart.resize();
        // });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.card-border
  padding 0 10px
  height 100%

.tjBox
  width 100%
  height 100%
  display flex
  justify-content space-between

.tjList
  width 30%
  position relative

.tjList img
  width 100%

.tjImgBox
  position relative
  >p
    display inline-block
    position absolute
    left 0
    right 0
    bottom 0
    height 28px
    line-height 28px
    // padding 0 10px
    text-align right
    color #fff
    background rgba(0, 0, 0, .4)
    white-space nowrap
    overflow hidden
    text-overflow ellipsis

.nopx-imgYuan
  width 8px
  height 8px
  background #000
  border 2px solid #00ffff
  border-radius 50%
  margin 0 auto

.nopx-imgLine
  width 0
  height 3px
  border 1px #00ffff dotted
  margin 0 auto

.imgMsg
  position absolute
  bottom 0
  left 50%
  width 100%
  transform translate(-50%, 0)

.tiImgBox
  // height calc(100% - 31px)
  margin-top 10px
  height calc(100% - 50px)
  position relative

.swiper-container
  height 100%

.imgMsg p
  color #fff
  padding-top 1px
  text-align center

.bchLine
  position absolute
  bottom 30px
  left 50%
  transform translate(-50%, 50%)
  width 100%
  z-index 1

.swiper-button-prev, .swiper-button-next
  height 18px

.swiper-button-next
  right 0

.swiper-button-prev
  left 0

.chart-box
  height calc(100% - 50px)
  margin-top 10px

.clzsBox, .clzybBox
  height calc(50% - 10px)

.bchTitle
  color #fff
  width max-content
  line-height 2
  background rgb(12, 67, 150)
  border-radius 20px
  padding 0 10px

.chart
  height calc(100% - 31px)

.chart2
  height calc(100% - 60px)

/deep/.el-tabs__header
  margin 0
/deep/ .el-tabs
  padding-left 10px
  marign-bottom 4px
  box-sizing border-border-box
/deep/.el-tabs__item
  height 30px
  line-height 30px
  color #fff
  font-size 13px

/deep/.el-tabs__item.is-active
  color rgb(243, 208, 19)

/deep/.el-tabs__nav-wrap::after
  height 0

/deep/.el-tabs__active-bar
  background rgb(243, 208, 19)
</style>
